import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, FormGroupDirective , Validators } from "@angular/forms";
import { SameNumberValidator } from "src/app/directives/same-number.directive";
import { Bulto } from "src/app/models/Dte/Exportacion/Bulto";
import { CodigosAduana } from "src/app/models/Dte/Exportacion/CodigosAduana";
import { Pais } from "src/app/models/Dte/Exportacion/Pais";
import { Puerto } from "src/app/models/Dte/Exportacion/Puerto";
import { UnidadMedida } from "src/app/models/Dte/Exportacion/UnidadMedida";
import { ViaTransporte } from "src/app/models/Dte/Exportacion/ViaTransporte";
import { ExportacionTransporteDte } from "src/app/models/Dte/exportacionDte";
import { esIndicadorServicioLocalExportacion, INDICADORES_SERVICIO_LOCAL_EXPORTACION } from "src/app/models/Dte/IndicadorServicio.enum";

import { FacturacionIndividualService } from "src/app/services/facturacion-individual.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";

@Component({
	selector: "app-exportacion-dte",
	templateUrl: "./exportacion-dte.component.html",
	styleUrls: ["./exportacion-dte.component.scss"],
})
export class ExportacionDteComponent implements OnInit, OnChanges {
	@ViewChild("localForm") private localFormRef: FormGroupDirective ;
	@Input() estadoExportacion: ExportacionTransporteDte | null = null;
	public exportFormGroup: FormGroup | null = null;
	public paisesSource: Pais[] = [];
	public viaTransporteSource: ViaTransporte[] = [];
	public puertosNacionalesSource: Puerto[] = [];
	public puertosDesembarqueSource: Puerto[] = [];
	public selectionDesembarqueSource: Puerto[] = [];
	public selectionEmbarqueSource: Puerto[] = [];
	public unidadesMedidaSource: UnidadMedida[];
	public bultosGuardados: Bulto[] | null = null;
	public isLocalService: boolean = false;
	public subTab: "aduanas" | "bultos" = "aduanas";

	selectSubTab(tab: "aduanas" | "bultos"): void {
		this.subTab = tab;
	}
	private exportacionDte: ExportacionTransporteDte = new ExportacionTransporteDte();
	private packagesList: Bulto[] = [];
	private codigosAduana: CodigosAduana;
	private restaurandoDatos: boolean = false;
	private formReady = false;
	private pendingEstado: ExportacionTransporteDte | null | undefined = null;
	@Output() indicadorServicioChange = new EventEmitter<number>();		
	@Input() indicadorServicioInicial: number | null = null;
	indicadoresServicio = INDICADORES_SERVICIO_LOCAL_EXPORTACION;
	constructor(private formBuilder: FormBuilder, private facturador: FacturacionIndividualService, private localStorage: LocalStorageService, private ref: ChangeDetectorRef, private utilities: UtilitiesService) {}

	ngOnInit(): void {
		this.codigosAduana = this.localStorage.getCodigosAduana();
		this.puertosNacionalesSource = this.codigosAduana.puertos;
		this.filterNationalPorts(environment.country_code_port);
		this.paisesSource = this.codigosAduana.paises;
		this.puertosDesembarqueSource = this.codigosAduana.puertos;
		this.viaTransporteSource = this.codigosAduana.viaTransportes;
		this.utilities.sortAlphabeth(this.viaTransporteSource, "descripcion");
		this.unidadesMedidaSource = this.codigosAduana.unidadMedidas;
		this.utilities.sortAlphabeth(this.unidadesMedidaSource, "nombreUnidadMedida");
		this.filterPortBySelectedCountry();
		this.setExportForm();
		if (esIndicadorServicioLocalExportacion(this.indicadorServicioInicial)) {
			this.exportFormGroup.get('indicadorServicio')?.patchValue(this.indicadorServicioInicial, { emitEvent: false });
		}

		this.formReady = true;
		this.aplicarEstadoExportacion(this.pendingEstado ?? this.estadoExportacion);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.estadoExportacion) {
			this.pendingEstado = changes.estadoExportacion.currentValue;
			if (this.formReady) {
			this.aplicarEstadoExportacion(this.pendingEstado);
			}
		}
	}
	onIndicadorServicioChanged(option: any) {
		const value = option?.value ?? null;
		this.indicadorServicioChange.emit(value);
		this.onSubmit();
	}

	


	setExportForm() {
		this.exportFormGroup = this.formBuilder.group(
			{
				tara: [0, [Validators.required, Validators.pattern("^[0-9]+$")]],
				medidaTara: [this.unidadesMedidaSource[this.getIndexForArrayItem("abreviatura", "KN", this.unidadesMedidaSource)], [Validators.required]],
				pesoNeto: [0, [Validators.required]],
				medidaPesoNeto: [this.unidadesMedidaSource[this.getIndexForArrayItem("abreviatura", "KN", this.unidadesMedidaSource)], [Validators.required]],
				pesoBruto: [0, [Validators.required]],
				totalBultos: [0, [Validators.required]],
				flete: [0, [Validators.required]],
				seguro: [0, [Validators.required]],
				viaTransporte: [this.viaTransporteSource[4], [Validators.required]],
				paisReceptor: [this.paisesSource[0], [Validators.required]],
				puertoEmbarque: [this.selectionEmbarqueSource[0]],
				puertoDesembarque: [this.selectionDesembarqueSource[0]],
				indicadorServicio: [{ value: null, disabled: true }],
			},
			{ validators: SameNumberValidator }
		);
		this.exportFormGroup.controls.pesoBruto.disable();
	}

	onSubmit() {
		this.exportacionDte.tara = this.exportFormGroup.controls.tara.value;
		this.exportacionDte.pesoNeto = this.exportFormGroup.controls.pesoNeto.value;
		this.exportacionDte.pesoBruto = +this.exportacionDte.tara + +this.exportacionDte.pesoNeto;
		this.exportFormGroup.controls.pesoBruto.patchValue(this.exportacionDte.pesoBruto, { emitEvent: false });
		

		if (!this.exportFormGroup.valid) {
			return;
		}

		if (this.isLocalService) {
			this.exportacionDte.haveTransport = false;
			this.exportacionDte.tara = 0;
			this.exportacionDte.pesoNeto = 0;
			this.exportacionDte.pesoBruto = 0;
			this.exportacionDte.flete = 0;
			this.exportacionDte.seguro = 0;
			this.exportacionDte.viaTransporte = undefined;
			this.exportacionDte.codigoViaTransporte = undefined;
			this.exportacionDte.paisReceptor = undefined	;
			this.exportacionDte.codigoPaisReceptor = undefined;
			this.exportacionDte.codigoPaisDestino = undefined;
			this.exportacionDte.puertoEmbarque = undefined;
			this.exportacionDte.codigoPuertoEmbarque = undefined;
			this.exportacionDte.puertoDesembarque = undefined;
			this.exportacionDte.codigoPuertoDesembarque = undefined;
			this.exportacionDte.listaBultos = [];
			this.exportacionDte.totalBultos = "0";

			if (!this.restaurandoDatos) {
			this.facturador.updateExportacionTransporte(this.exportacionDte);
			}
			return;
		}

		const unidadMedidaTara: UnidadMedida = this.exportFormGroup.controls.medidaTara.value;
		this.exportacionDte.medidaTara = unidadMedidaTara ? unidadMedidaTara.codigoSigla : undefined;
		const unidadMedida: UnidadMedida = this.exportFormGroup.controls.medidaPesoNeto.value;
		this.exportacionDte.medidaPesoNeto = unidadMedida ? unidadMedida.codigoSigla : undefined;
		this.exportacionDte.medidaPesoBruto = unidadMedida ? unidadMedida.codigoSigla : undefined;
		this.exportacionDte.pesoBruto = +this.exportacionDte.tara + +this.exportacionDte.pesoNeto;
		this.exportFormGroup.controls.pesoBruto.patchValue(this.exportacionDte.pesoBruto, { emitEvent: false });
		this.exportacionDte.flete = this.exportFormGroup.controls.flete.value;
		this.exportacionDte.seguro = this.exportFormGroup.controls.seguro.value;
		const viaTransporte: ViaTransporte = this.exportFormGroup.controls.viaTransporte.value;
		this.exportacionDte.viaTransporte = viaTransporte ? viaTransporte.descripcion.toString() : undefined;
		this.exportacionDte.codigoViaTransporte = viaTransporte ? viaTransporte.codigoSii : undefined;
		const paisSelected: Pais = this.exportFormGroup.controls.paisReceptor.value;
		this.exportacionDte.paisReceptor = paisSelected ? paisSelected.nombre : undefined;
		this.exportacionDte.codigoPaisReceptor = paisSelected ? paisSelected.codigoSii : undefined;
		this.exportacionDte.codigoPaisDestino = paisSelected ? paisSelected.codigoSii : undefined;
		const paisEmisor = this.paisesSource.find((pais) => pais.paisId == environment.country_code_port);
		this.exportacionDte.paisEmisor = paisEmisor ? paisEmisor.nombre : undefined;
		const puertoNacional: Puerto = this.exportFormGroup.controls.puertoEmbarque.value;
		this.exportacionDte.puertoEmbarque = puertoNacional ? puertoNacional.puertoId : undefined;
		this.exportacionDte.codigoPuertoEmbarque = puertoNacional ? puertoNacional.codigoSii : undefined;
		const puertoDestino: Puerto = this.exportFormGroup.controls.puertoDesembarque.value;
		this.exportacionDte.puertoDesembarque = puertoDestino ? puertoDestino.puertoId : undefined;
		this.exportacionDte.codigoPuertoDesembarque = puertoDestino ? puertoDestino.codigoSii : undefined;
		this.exportacionDte.territorioEmbarque = puertoNacional ? puertoNacional.territorio : undefined;
		this.exportacionDte.territorioDesembarque = puertoDestino ? puertoDestino.territorio : undefined;
		this.exportacionDte.haveTransport = !this.isLocalService;

		if (!this.isLocalService) {
			if (!this.packagesList || this.packagesList.length === 0) {
				this.exportFormGroup.controls.totalBultos.setErrors({ requiredBultos: true });
				this.exportFormGroup.controls.totalBultos.markAsTouched();
				return;
			}
			this.exportacionDte.listaBultos = this.packagesList;
			const sumListQuantities = this.calcularTotalBultos(this.packagesList);
			this.exportFormGroup.controls.totalBultos.patchValue(sumListQuantities, { emitEvent: false });
			this.exportacionDte.totalBultos = sumListQuantities.toString();
		} else {
			this.exportacionDte.listaBultos = this.packagesList;
			this.exportacionDte.totalBultos = "0";
			this.exportFormGroup.controls.totalBultos.patchValue(0, { emitEvent: false });
		}

		if (!this.restaurandoDatos) {
			this.facturador.updateExportacionTransporte(this.exportacionDte);
		}
	}

	getPackagesList($event) {
		this.packagesList = Array.isArray($event) ? $event : [];
		this.exportacionDte.listaBultos = this.packagesList;

		if (this.isLocalService) {
			this.exportacionDte.totalBultos = "0";
			this.exportFormGroup.controls.totalBultos.patchValue(0, { emitEvent: false });
			return;
		}
		if (!this.packagesList.length) {
			return;
		}

		const sumListQuantities = this.calcularTotalBultos(this.packagesList);
		this.exportFormGroup.controls.totalBultos.patchValue(sumListQuantities, { emitEvent: false });
		this.exportacionDte.totalBultos = sumListQuantities.toString();

		if (!this.restaurandoDatos) {
			this.onSubmit();
		}
	}

	changeLocalService($event) {
		this.isLocalService = $event.target.checked;
		if (this.isLocalService) {
			this.subTab = "aduanas";
		} else {
			this.indicadorServicioChange.emit(null);
		}
		this.actualizarValidacionesPorServicioLocal();
		this.onSubmit();
		if (this.exportFormGroup.invalid) {
			this.facturador.updateExportacionTransporte(this.exportacionDte);
		}
	}

	filterPortBySelectedCountry() {
		if (this.exportFormGroup?.controls?.paisReceptor) {
			const selectedCountry: Pais = this.exportFormGroup.controls.paisReceptor.value;
			if (!selectedCountry) {
				return;
			}
			this.selectionDesembarqueSource = this.puertosDesembarqueSource.filter((puerto) => puerto.codigoPais == selectedCountry.paisId);
			this.utilities.sortAlphabeth(this.selectionDesembarqueSource, "nombrePuerto");
			const puertoPorDefecto = this.selectionDesembarqueSource[0];
			if (puertoPorDefecto) {
				this.exportFormGroup.controls.puertoDesembarque.patchValue(puertoPorDefecto, { emitEvent: false });
			}
		}
	}

	filterNationalPorts(code: number) {
		this.selectionEmbarqueSource = this.puertosNacionalesSource.filter((puerto) => puerto.codigoPais == code);
		this.utilities.sortAlphabeth(this.selectionEmbarqueSource, "nombrePuerto");
	}

	getIndexForArrayItem(propertyName: string, propertyValue: string, searchArray: any[]): number {
		return searchArray.findIndex((item) => item[propertyName] == propertyValue);
	}

	private aplicarEstadoExportacion(estado: ExportacionTransporteDte | null | undefined): void {
		if (!this.exportFormGroup) {
			return;
		}

		const exportacion = Object.assign(new ExportacionTransporteDte(), estado ?? {});
		if (exportacion.haveTransport !== undefined) {
			this.isLocalService = !exportacion.haveTransport;
		}
		const tieneContenido = this.exportacionTieneContenido(exportacion);
		this.restaurandoDatos = true;

		if (tieneContenido) {
			this.exportacionDte = exportacion;
			this.packagesList = (exportacion.listaBultos ?? []).map((bulto) => Object.assign(new Bulto(), bulto));
			const totalBultos = this.calcularTotalBultos(this.packagesList);
			this.exportacionDte.totalBultos = totalBultos.toString();
			this.exportacionDte.listaBultos = this.packagesList;
			this.bultosGuardados = this.packagesList.map((bulto) => Object.assign({}, bulto));
			if (exportacion.haveTransport !== undefined) {
				this.isLocalService = !exportacion.haveTransport;
			}
		} else {
			this.exportacionDte = new ExportacionTransporteDte();
			this.packagesList = [];
			this.bultosGuardados = null;
		}

		this.actualizarValidacionesPorServicioLocal(false);

		const patch: any = {};
		if (tieneContenido) {
			if (exportacion.tara !== undefined) {
				patch.tara = exportacion.tara;
			}
			const unidadTara = this.obtenerUnidadPorCodigo(exportacion.medidaTara);
			if (unidadTara) {
				patch.medidaTara = unidadTara;
			}
			if (exportacion.pesoNeto !== undefined) {
				patch.pesoNeto = exportacion.pesoNeto;
			}
			const unidadPeso = this.obtenerUnidadPorCodigo(exportacion.medidaPesoNeto);
			if (unidadPeso) {
				patch.medidaPesoNeto = unidadPeso;
			}
			if (exportacion.pesoBruto !== undefined) {
				patch.pesoBruto = exportacion.pesoBruto;
			}
			if (exportacion.flete !== undefined) {
				patch.flete = exportacion.flete;
			}
			if (exportacion.seguro !== undefined) {
				patch.seguro = exportacion.seguro;
			}
			const via = this.obtenerViaPorCodigo(exportacion.codigoViaTransporte, exportacion.viaTransporte);
			if (via) {
				patch.viaTransporte = via;
			}
			const pais = this.obtenerPaisPorCodigo(exportacion.codigoPaisReceptor, exportacion.paisReceptor);
			if (pais) {
				patch.paisReceptor = pais;
				this.selectionDesembarqueSource = this.puertosDesembarqueSource.filter((puerto) => puerto.codigoPais == pais.paisId);
				this.utilities.sortAlphabeth(this.selectionDesembarqueSource, "nombrePuerto");
				const puertoDestino = this.obtenerPuertoPorId(this.selectionDesembarqueSource, exportacion.puertoDesembarque, exportacion.codigoPuertoDesembarque);
				if (puertoDestino) {
					patch.puertoDesembarque = puertoDestino;
				}
			} else {
				this.filterPortBySelectedCountry();
			}
			const puertoNacional = this.obtenerPuertoPorId(this.puertosNacionalesSource, exportacion.puertoEmbarque, exportacion.codigoPuertoEmbarque);
			if (puertoNacional) {
				patch.puertoEmbarque = puertoNacional;
			}
			if (!this.isLocalService) {
				const totalBultos = this.exportacionDte.totalBultos ?? this.calcularTotalBultos(this.packagesList);
				patch.totalBultos = totalBultos;
			}
		} else {
			this.filterPortBySelectedCountry();
		}

		if (Object.keys(patch).length > 0) {
			this.exportFormGroup.patchValue(patch, { emitEvent: false });
		}

		if (!this.isLocalService) {
			const total = this.exportacionDte.totalBultos ?? this.calcularTotalBultos(this.packagesList);
			this.exportFormGroup.controls.totalBultos.patchValue(total, { emitEvent: false });
		} else {
			this.exportFormGroup.controls.totalBultos.patchValue(0, { emitEvent: false });
		}

		this.restaurandoDatos = false;
	}

	private exportacionTieneContenido(exportacion: ExportacionTransporteDte): boolean {
		if (!exportacion) {
			return false;
		}
		const tieneBultos = (exportacion.haveTransport !== false) && (exportacion.listaBultos && exportacion.listaBultos.length > 0);
		return (
			tieneBultos ||
			exportacion.tara !== undefined ||
			exportacion.pesoNeto !== undefined ||
			exportacion.flete !== undefined ||
			exportacion.seguro !== undefined ||
			exportacion.codigoViaTransporte !== undefined ||
			exportacion.viaTransporte !== undefined ||
			exportacion.puertoEmbarque !== undefined ||
			exportacion.puertoDesembarque !== undefined ||
			exportacion.codigoPaisReceptor !== undefined ||
			exportacion.paisReceptor !== undefined ||
			exportacion.haveTransport !== undefined
		);
	}

	private obtenerUnidadPorCodigo(codigo?: number): UnidadMedida | undefined {
		return this.unidadesMedidaSource?.find((unidad) => unidad.codigoSigla === codigo);
	}

	private obtenerViaPorCodigo(codigo?: number, descripcion?: string): ViaTransporte | undefined {
		return this.viaTransporteSource?.find((via) => (codigo !== undefined && via.codigoSii === codigo) || (!!descripcion && via.descripcion === descripcion));
	}

	private obtenerPaisPorCodigo(codigo?: number, nombre?: string): Pais | undefined {
		return this.paisesSource?.find((pais) => (codigo !== undefined && pais.codigoSii === codigo) || (!!nombre && pais.nombre === nombre));
	}

	private obtenerPuertoPorId(lista: Puerto[], id?: number, codigo?: number): Puerto | undefined {
		return lista?.find((puerto) => (id !== undefined && puerto.puertoId === id) || (codigo !== undefined && puerto.codigoSii === codigo));
	}

	private calcularTotalBultos(bultos: Bulto[]): number {
		return (bultos ?? []).reduce((sum, current) => sum + (current?.cantidadBultos ?? 0), 0);
	}

	private actualizarValidacionesPorServicioLocal(marcarFormulario: boolean = true): void {
		if (!this.exportFormGroup) {
			return;
		}

		this.exportacionDte.haveTransport = !this.isLocalService;

		if (marcarFormulario && this.localFormRef && !this.localFormRef.form.touched) {
			this.localFormRef.form.markAsTouched();
		}

		const camposTransporte = [
			"tara",
			"medidaTara",
			"pesoNeto",
			"medidaPesoNeto",
			"flete",
			"seguro",
			"viaTransporte",
			"paisReceptor",
			"puertoEmbarque",
			"puertoDesembarque",
		];

		const indicadorCtrl = this.exportFormGroup.get("indicadorServicio");

		if (this.isLocalService) {
			camposTransporte.forEach((key) => {
			const control = this.exportFormGroup!.get(key);
			control?.disable({ emitEvent: false });
			control?.setErrors(null);
			});
			this.exportFormGroup.patchValue(
			{
				tara: 0,
				pesoNeto: 0,
				pesoBruto: 0,
				totalBultos: 0,
				flete: 0,
				seguro: 0,
				viaTransporte: null,
				paisReceptor: null,
				puertoEmbarque: null,
				puertoDesembarque: null,
			},
			{ emitEvent: false }
			);
			this.packagesList = [];
			this.bultosGuardados = null;
			this.exportacionDte.listaBultos = [];
			this.exportacionDte.totalBultos = "0";
			indicadorCtrl?.enable({ emitEvent: false });
			indicadorCtrl?.setValidators([
				Validators.required,
				(control) => esIndicadorServicioLocalExportacion(control.value) ? null : { indicadorServicioInvalido: true },
			]);
			indicadorCtrl?.updateValueAndValidity({ emitEvent: false });
		} else {
			camposTransporte.forEach((key) => {
			const control = this.exportFormGroup!.get(key);
			control?.enable({ emitEvent: false });
			control?.updateValueAndValidity({ emitEvent: false });
			});
			indicadorCtrl?.reset(null, { emitEvent: false });
			indicadorCtrl?.clearValidators();
			indicadorCtrl?.disable({ emitEvent: false });
			indicadorCtrl?.updateValueAndValidity({ emitEvent: false });
			const total = this.calcularTotalBultos(this.packagesList);
			this.exportFormGroup.controls.totalBultos.patchValue(total, { emitEvent: false });
		}

		this.exportFormGroup.updateValueAndValidity({ emitEvent: false });
		this.localFormRef?.form.updateValueAndValidity();
		this.ref.detectChanges();
	}

}
